import React from 'react';
import { Home, ArrowLeft, Phone } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." noindex />
      <Navigation />

      <section className="pt-32 pb-20 bg-gradient-to-br from-[#00594C] to-[#003d35] min-h-[60vh] flex items-center">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-xl mx-auto">
            <div className="text-8xl font-bold text-[#99DF63] mb-4">404</div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Page Not Found
            </h1>
            <p className="text-lg text-gray-200 mb-8">
              Sorry, the page you're looking for doesn't exist or has been moved. Let's get you back on track.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/"
                className="inline-flex items-center justify-center space-x-2 bg-[#99DF63] text-[#00594C] px-8 py-4 rounded-full font-bold text-lg hover:bg-[#8BCF52] transition-all shadow-lg"
              >
                <Home className="w-5 h-5" />
                <span>Go Home</span>
              </a>
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white/20 transition-all border border-white/30"
              >
                <ArrowLeft className="w-5 h-5" />
                <span>Go Back</span>
              </button>
            </div>
            <p className="mt-8 text-gray-300">
              Need help? Call us on{' '}
              <a href="tel:+61468007056" className="text-[#99DF63] font-semibold hover:underline inline-flex items-center space-x-1">
                <Phone className="w-4 h-4" />
                <span>0468 007 056</span>
              </a>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFound;
